/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="defaultValue" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="freshness" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="loadAsNeeded" type="{http://www.w3.org/2001/XMLSchema}boolean" minOccurs="0"/&gt; &lt;choice minOccurs="0"&gt; &lt;element name="parameterMapEntry" maxOccurs="unbounded" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="key" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="value" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="queryItemMap" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="keyRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="valueRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;/choice&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class ParameterMap extends ObjectType{

	defaultValue = null;

	freshness = null;

	loadAsNeeded = null;

	parameterMapEntry = null;

	queryItemMap = null;



	/**
	 * Gets the value of the defaultValue property.
	 * @return {String} possible object is {@link String}
	 */
	getDefaultValue() {
		return this.defaultValue;
	}

	/**
	 * Sets the value of the defaultValue property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDefaultValue(value) {
		var oldValue = this.defaultValue;
		this.defaultValue = value;
		this._setAndNotify(43, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the freshness property.
	 * @return {String} possible object is {@link String}
	 */
	getFreshness() {
		return this.freshness;
	}

	/**
	 * Sets the value of the freshness property.
	 * @param {String} value allowed object is {@link String}
	 */
	setFreshness(value) {
		var oldValue = this.freshness;
		this.freshness = value;
		this._setAndNotify(44, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the loadAsNeeded property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isLoadAsNeeded() {
		return this.loadAsNeeded;
	}

	/**
	 * Sets the value of the loadAsNeeded property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setLoadAsNeeded(value) {
		var oldValue = this.loadAsNeeded;
		this.loadAsNeeded = value;
		this._setAndNotify(45, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the parameterMapEntry property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the parameterMapEntry property. <p> For example, to add a new item, do as follows: <pre> getParameterMapEntry().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ParameterMap.ParameterMapEntry}
	 */
	getParameterMapEntry() {
		if (!this.parameterMapEntry) {
			this.parameterMapEntry = [];
		}
		return this.parameterMapEntry;
	}

	/**
	 * Gets the value of the queryItemMap property.
	 * @return {QueryItemMap} possible object is {@link ParameterMap.QueryItemMap}
	 */
	getQueryItemMap() {
		return this.queryItemMap;
	}

	/**
	 * Sets the value of the queryItemMap property.
	 * @param {QueryItemMap} value allowed object is {@link ParameterMap.QueryItemMap}
	 */
	setQueryItemMap(value) {
		var oldValue = this.queryItemMap;
		this.queryItemMap = value;
		this._setAndNotify(47, oldValue, value, true, true);
	}

	/**
	 * Gets the value of the <code>parameterMapEntry</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ParameterMapEntry</code> elements, or <code>null</code> if not set
	 */
	basicGetParameterMapEntry() {
		return this.parameterMapEntry;
	}

	/**
	 * Creates a new instance of <code>ParameterMap</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ParameterMap</code> object from.
	 * @return {ParameterMap} an object of type <code>ParameterMap</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createParameterMap();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addParameterMapEntryAt(position, item) {
		this._addAtAndNotify(this.getParameterMapEntry(), position, item, 46, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addParameterMapEntry(item) {
		this.addParameterMapEntryAt(this.getParameterMapEntry().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeParameterMapEntryAt(position) {
		this._removeAtAndNotify(this.getParameterMapEntry(), position, 46, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeParameterMapEntry(item) {
		var i = this.getParameterMapEntry().indexOf(item);
		if (i >= 0) {
			this.removeParameterMapEntryAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ParameterMap";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 43, "defaultValue", null));
		featureList.push(this.createFeature(false, false, false, 44, "freshness", null));
		featureList.push(this.createFeature(false, false, false, 45, "loadAsNeeded", null));
		var clazz;
		if (factory) {
			clazz = factory.createParameterMapParameterMapEntry().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 46, "parameterMapEntry", clazz));
		if (factory) {
			clazz = factory.createParameterMapQueryItemMap().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 47, "queryItemMap", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 43:
			this.setDefaultValue((value));
			break;
		case 44:
			this.setFreshness((value));
			break;
		case 45:
			this.setLoadAsNeeded((value));
			break;
		case 47:
			this.setQueryItemMap((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 46:
			this.parameterMapEntry = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 43:
			return this.getDefaultValue();
		case 44:
			return this.getFreshness();
		case 45:
			return this.isLoadAsNeeded();
		case 46:
			return this.getParameterMapEntry();
		case 47:
			return this.getQueryItemMap();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 43:
			return this.getDefaultValue();
		case 44:
			return this.getFreshness();
		case 45:
			return this.isLoadAsNeeded();
		case 46:
			return this.basicGetParameterMapEntry();
		case 47:
			return this.getQueryItemMap();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 46:
			this.addParameterMapEntryAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 46:
			this.addParameterMapEntry((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 46:
			this.removeParameterMapEntryAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 46:
			this.removeParameterMapEntry((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="key" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="value" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
ParameterMap.ParameterMapEntry = class extends MoserObject{

	key = null;

	value = null;



	/**
	 * Gets the value of the key property.
	 * @return {String} possible object is {@link String}
	 */
	getKey() {
		return this.key;
	}

	/**
	 * Sets the value of the key property.
	 * @param {String} value allowed object is {@link String}
	 */
	setKey(value) {
		var oldValue = this.key;
		this.key = value;
		this._setAndNotify(87, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the value property.
	 * @return {String} possible object is {@link String}
	 */
	getValue() {
		return this.value;
	}

	/**
	 * Sets the value of the value property.
	 * @param {String} value allowed object is {@link String}
	 */
	setValue(value) {
		var oldValue = this.value;
		this.value = value;
		this._setAndNotify(130, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>ParameterMapEntry</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ParameterMapEntry</code> object from.
	 * @return {ParameterMapEntry} an object of type <code>ParameterMapEntry</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createParameterMapParameterMapEntry();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ParameterMapEntry";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 87, "key", null));
		featureList.push(this.createFeature(false, false, false, 130, "value", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 87:
			this.setKey((value));
			break;
		case 130:
			this.setValue((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 87:
			return this.getKey();
		case 130:
			return this.getValue();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 87:
			return this.getKey();
		case 130:
			return this.getValue();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="keyRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="valueRef" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
ParameterMap.QueryItemMap = class extends MoserObject{

	keyRef = null;

	valueRef = null;



	/**
	 * Gets the value of the keyRef property.
	 * @return {String} possible object is {@link String}
	 */
	getKeyRef() {
		return this.keyRef;
	}

	/**
	 * Sets the value of the keyRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setKeyRef(value) {
		var oldValue = this.keyRef;
		this.keyRef = value;
		this._setAndNotify(181, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the valueRef property.
	 * @return {String} possible object is {@link String}
	 */
	getValueRef() {
		return this.valueRef;
	}

	/**
	 * Sets the value of the valueRef property.
	 * @param {String} value allowed object is {@link String}
	 */
	setValueRef(value) {
		var oldValue = this.valueRef;
		this.valueRef = value;
		this._setAndNotify(240, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>QueryItemMap</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> QueryItemMap</code> object from.
	 * @return {QueryItemMap} an object of type <code>QueryItemMap</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createParameterMapQueryItemMap();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "QueryItemMap";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 181, "keyRef", null));
		featureList.push(this.createFeature(false, false, false, 240, "valueRef", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 181:
			this.setKeyRef((value));
			break;
		case 240:
			this.setValueRef((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 181:
			return this.getKeyRef();
		case 240:
			return this.getValueRef();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 181:
			return this.getKeyRef();
		case 240:
			return this.getValueRef();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/ParameterMap.js